// assets/randomize-collection-grid.js
(() => {
  // Always randomize (ignore sort_by)
  const IMAGE_TIMEOUT = 1500;                // ms: max wait for images after shuffle
  const CONTAINER_SEL = '#ProductGridContainer';
  const GRID_SEL = 'ul#product-grid';
  const OVERLAY_ID = 'randomize-global-overlay';

  let isRandomizing = false;
  let observer = null;
  let scheduled = null;

  function ensureGlobalOverlay() {
    let ov = document.getElementById(OVERLAY_ID);
    if (!ov) {
      ov = document.createElement('div');
      ov.id = OVERLAY_ID;
      ov.className = 'randomize-global-overlay';
      ov.innerHTML = '<span class="loader" aria-hidden="true"></span>';
      document.body.appendChild(ov);
    }
    return ov;
  }

  function showOverlay() {
    const ov = ensureGlobalOverlay();
    ov.style.display = 'flex';
    document.documentElement.classList.add('randomizing');
    document.body.classList.add('randomizing');
    document.body.setAttribute('aria-busy', 'true');
  }

  function hideOverlay() {
    const ov = document.getElementById(OVERLAY_ID);
    if (ov) ov.style.display = 'none';
    document.documentElement.classList.remove('randomizing');
    document.body.classList.remove('randomizing');
    document.body.removeAttribute('aria-busy');
  }

  function getEls() {
    const container = document.querySelector(CONTAINER_SEL);
    if (!container) return {};
    const grid = container.querySelector(GRID_SEL);
    return { container, grid };
  }

  function waitForImages(scope, timeout = IMAGE_TIMEOUT) {
    const imgs = Array.from(scope.querySelectorAll('img'));
    if (!imgs.length) return Promise.resolve();
    const doneNow = imgs.every(img => img.complete && img.naturalWidth > 0);
    if (doneNow) return Promise.resolve();

    return new Promise(resolve => {
      let done = 0;
      let finished = false;
      const finish = () => { if (!finished) { finished = true; resolve(); } };
      const onOne = () => { if (++done >= imgs.length) finish(); };
      imgs.forEach(img => {
        if (img.complete && img.naturalWidth > 0) onOne();
        else {
          img.addEventListener('load', onOne, { once: true });
          img.addEventListener('error', onOne, { once: true });
        }
      });
      setTimeout(finish, timeout);
    });
  }

  function shuffleNodes(nodes) {
    for (let i = nodes.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [nodes[i], nodes[j]] = [nodes[j], nodes[i]];
    }
    return nodes;
  }

  function randomizeGrid() {
    const { container, grid } = getEls();
    if (!container || !grid) return;
    if (isRandomizing || grid.dataset.randomized === 'true') return;

    const items = Array.from(grid.querySelectorAll('.grid__item'));
    if (items.length < 2) { grid.dataset.randomized = 'true'; return; }

    isRandomizing = true;
    showOverlay();

    // Shuffle DOM nodes
    const shuffled = shuffleNodes(items.slice());
    const frag = document.createDocumentFragment();
    shuffled.forEach(el => frag.appendChild(el));
    grid.appendChild(frag);

    // Wait a moment for layout and images, then hide
    requestAnimationFrame(() => {
      waitForImages(grid, IMAGE_TIMEOUT).finally(() => {
        grid.dataset.randomized = 'true';
        hideOverlay();
        isRandomizing = false;
      });
    });
  }

  function onMutations() {
    if (scheduled) return;
    scheduled = requestAnimationFrame(() => {
      scheduled = null;
      randomizeGrid();
    });
  }

  function initObserver() {
    const { container } = getEls();
    if (!container) return;
    if (observer) observer.disconnect();
    observer = new MutationObserver(onMutations);
    observer.observe(container, { childList: true, subtree: true });
  }

  function init() {
    randomizeGrid();
    initObserver();
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', randomizeGrid);
  document.addEventListener('shopify:section:load', init);
})();